import React from "react";
import styled from "styled-components";
import { switchPerformanceColor } from "../Global/tools.js";

import NanoFlex from "../Global/NanoFlex";
import { ReactComponent as PerformanceIndicatorCorner } from "../Global/Icons/PerformanceIndicatorCorner.svg";

const StyledPerformanceColor = styled(PerformanceIndicatorCorner)`
  vertical-align: bottom;
  path {
    fill: ${props => props.color};
  }
`;

const PerformanceColor = props => {
  if (props.color) {
    return <StyledPerformanceColor color={switchPerformanceColor(props.color)} />;
  } else {
    return null;
  }
};

export default PerformanceColor;

// --- // Documentation // --- //
/*

import PerformanceColor from './../Nano/PerformanceColor.js';

<PerformanceColor color={} />
*/
